import Main from '~/components/main';
import Banners from '~/components/molecules/banners/Banners';
import SearchOverview from '~/components/molecules/searchOverview/searchOverview';
import Categories from '~/components/organisms/category/Categories';
import FullText from '~/components/organisms/fulltext/Fulltext';
import FulltextContainer from '~/components/organisms/fulltext/fulltextContainer';
import FulltextResultHeading from '~/components/organisms/fulltext/fulltextSingleResult/FulltextResultHeading';
import FulltextResultWrapper from '~/components/organisms/fulltext/fulltextSingleResult/FulltextResultWrapper';
import FulltextSingleResult from '~/components/organisms/fulltext/fulltextSingleResult/FulltextSingleResult';
import InstantSearchBackdrop from '~/components/organisms/instantSearch/instantSearchBackdrop';
import ProductResultPrice from '~/components/organisms/products/productSingleResult/ProductResultPrice';
import ProductSingleResult from '~/components/organisms/products/productSingleResult/ProductSingleResult';
import ProductColors from '../packages/dekorhome/components/organisms/products/productSingleResult/ProductColors';
import ProductResultImage from '../packages/ivarcs/components/organisms/products/productSingleResult/productResultImage';
import ProductResultHead from '../packages/kia/components/organisms/products/productSingleResult/productResultHead';

/**
 * Dynamic components that can be loaded from plugins or main application
 */
export type DynamicComponents = {
    Main: typeof Main;
    Banners: typeof Banners;
    FullText: typeof FullText;
    FulltextResultHeading: typeof FulltextResultHeading;
    FulltextResultWrapper: typeof FulltextResultWrapper;
    Categories: typeof Categories;
    ProductSingleResult: typeof ProductSingleResult;
    ProductResultImage: typeof ProductResultImage;
    ProductResultPrice: typeof ProductResultPrice;
    ProductResultHead: typeof ProductResultHead;
    ProductColors: typeof ProductColors;
    SearchOverview: typeof SearchOverview;
    FulltextSingleResult: typeof FulltextSingleResult;
    InstantSearchBackdrop: typeof InstantSearchBackdrop;
    FulltextContainer: typeof FulltextContainer;
};

export const DynamicComponentPaths = {
    Main: 'main',
    Banners: 'molecules/banners/Banners',
    FullText: 'organisms/fulltext/Fulltext',
    FulltextResultHeading: 'organisms/fulltext/fulltextSingleResult/FulltextResultHeading',
    FulltextResultWrapper: 'organisms/fulltext/fulltextSingleResult/FulltextResultWrapper',
    Categories: 'organisms/category/Categories',
    ProductSingleResult: 'organisms/products/productSingleResult/ProductSingleResult',
    ProductResultImage: 'organisms/products/productSingleResult/productResultImage',
    ProductResultHead: 'organisms/products/productSingleResult/productResultHead',
    ProductColors: 'organisms/products/productSingleResult/ProductColors',
    SearchOverview: 'molecules/searchOverview/searchOverview',
    FulltextSingleResult: 'organisms/fulltext/fulltextSingleResult/FulltextSingleResult',
    ProductResultPrice: 'organisms/products/productSingleResult/ProductResultPrice',
    InstantSearchBackdrop: 'organisms/instantSearch/instantSearchBackdrop',
    FulltextContainer: 'organisms/fulltext/fulltextContainer',
} as const satisfies Record<keyof DynamicComponents, string>;
